import React, { useState, useCallback, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { authAPI } from "../services/AuthAPI";
import { Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Switch, CircularProgress, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import './managetype.css'

const EditPrefix = ({ isMobile, setLoadingPrefix, closeNav }) => {
    const dispatch = useDispatch()
    const { isLogin, isLoading, userData, loadingGetPrefix } = useSelector(state => state.user)

    const [data, setData] = useState([])

    useEffect(() => {
        if (isLogin) {
            dispatch({ type: "PREFIX_FETCH_START" })
            authAPI.getPrefixAdmin()
                .then((res) => {
                    if (res.status == 200) {
                        setData(res.message)
                    }
                    setTimeout(() => {
                        dispatch({ type: "PREFIX_FETCH_END" })
                    }, 500);
                })
                .catch((err) => {
                    setTimeout(() => {
                        dispatch({ type: "PREFIX_FETCH_END" })
                    }, 500);
                })
        }

    }, [isLogin])

    const UpdateStatus = useCallback((values) => {
        setLoadingPrefix(true)
        authAPI.updateStatus({ status: values.status, _id: values._id })
            .then((res) => {
                if (res.status == 200) {
                    let dataZ = [...data]
                    let findIndexdataZ = dataZ.findIndex((v) => v._id == res.message._id)
                    if (findIndexdataZ >= 0) {
                        dataZ[findIndexdataZ] = res.message
                    }
                    else {
                        dataZ = [...dataZ, res.message]
                    }
                    setData(dataZ)
                }
                setTimeout(() => {
                    setLoadingPrefix(false)
                }, 500)
            })
            .catch(error => {
                setTimeout(() => {
                    setLoadingPrefix(false)
                }, 500)
            })
    }, [data]);

    const useStyles = makeStyles(theme => ({
        root: {
            padding: theme.spacing(4, 3)
        },
    }));

    const classes = useStyles();

    return (
        !isLoading &&
        <div className='container h-100vh' style={{ display: closeNav ? 'block' : isMobile ? 'none' : 'block', marginTop: !isMobile ? 0 : '70px', justifyContent: 'flex-end', padding: !isMobile ? 'none' : '0' }}>
            <Paper className={`${classes.root} col-root`} style={{ boxShadow: 'none', padding: '3%' }}>
                <h3 style={{ fontSize: '38px' }}>จัดการ Prefix</h3>
                {userData?.permission?.add_prefix && <Typography component="div" style={{ padding: '12px' }}>
                    <Link to="add-prefix" style={{ textDecoration: 'none' }}>
                        <Button
                            variant="contained"
                            style={{
                                textTransform: 'none', backgroundColor: "#6ab23a", color: 'white', cursor: 'pointer', borderRadius: '28px'
                            }}>
                            <i style={{ marginRight: '8px' }} className='bx bx-folder-plus icon'></i> เพิ่ม Prefix
                        </Button>
                    </Link>
                </Typography>}
                <TableContainer component={Paper} style={{ borderRadius: '10px', marginTop: '1%', boxShadow: 'none', maxHeight: '75vh' }}>
                    <Table >
                        <TableHead style={{ backgroundColor: '#464B4F' }}>
                            <TableRow >
                                <TableCell style={{ textAlign: 'center', cursor: 'pointer', color: '#fff', fontSize: '18px', fontWeight: 500 }} className='col-TableCell'>ชื่อ Prefix</TableCell>
                                <TableCell style={{ textAlign: 'center', cursor: 'pointer', color: '#fff', fontSize: '18px', fontWeight: 500 }} className='col-TableCell'>Value Prefix</TableCell>
                                <TableCell style={{ textAlign: 'center', cursor: 'pointer', color: '#fff', fontSize: '18px', fontWeight: 500 }} className='col-TableCell'>สถานะ</TableCell>
                                {userData?.permission?.edit_prefix && <TableCell style={{ textAlign: 'center', cursor: 'pointer', color: '#fff', fontSize: '18px', fontWeight: 500 }}></TableCell>}
                            </TableRow>
                        </TableHead>
                        {!loadingGetPrefix ? <TableBody style={{ textAlign: 'center' }}>
                            {data.map((res, i) => (
                                <TableRow style={{ backgroundColor: 'transparent' }} key={i}>
                                    <TableCell style={{ textAlign: 'center', color: 'black', fontSize: '16px', fontWeight: 300 }}>{res.org_name}</TableCell>
                                    <TableCell style={{ textAlign: 'center', color: 'black', fontSize: '16px', fontWeight: 300 }}>{res.prefix || "-"}</TableCell>
                                    <TableCell style={{ textAlign: 'center', color: 'black', fontSize: '16px', fontWeight: 300 }}><Switch onClick={() => UpdateStatus(res)} checked={res.status} disabled={!userData?.permission?.edit_type} style={{ color: res.status ? '#6ab23a' : '#6C757D', cursor: 'pointer' }} /></TableCell>
                                    {userData?.permission?.edit_prefix && <TableCell style={{ textAlign: 'center', color: 'black', fontSize: '16px', fontWeight: 300 }}>
                                        <Link style={{ textDecoration: 'none' }} to={`edit-prefix/${res._id}`}>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                style={{
                                                    border: "2px solid transparent",
                                                    backgroundColor: 'transparent',
                                                    borderRadius: "10px",
                                                    color: "#6C757D",
                                                    fontSize: "14px",
                                                    textDecoration: "none",
                                                    textTransform: "none",
                                                    boxShadow: 'none'
                                                }}
                                            >
                                                <span style={{ textDecoration: 'underline', fontWeight: 'bold' }}>แก้ไข</span>
                                            </Button></Link></TableCell>}
                                </TableRow>
                            ))
                            }
                        </TableBody>
                            : <TableBody style={{ margin: 'auto' }}>
                                <TableRow>
                                    <TableCell> <CircularProgress size={30} style={{ color: '#6ab23a' }} /></TableCell>
                                </TableRow>
                            </TableBody>
                        }
                    </Table>
                </TableContainer >
            </Paper>
        </div>
    )
}
export default EditPrefix